import { Navigate, Outlet } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useBrand } from "@/contexts/BrandContext";
import { useSupportDesk } from "@/hooks/useSupportDesk";
import { APP_HOME_PATH } from "@/lib/copilot-home";

export function SupportDeskGuard() {
  const { session, loading, signOut } = useAuth();
  const brand = useBrand();
  const { supportDeskBrand, loading: deskLoading } = useSupportDesk(!loading && !!session);

  if (loading || deskLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!session) return <Navigate to="/login" replace />;
  if (!supportDeskBrand) return <Navigate to={APP_HOME_PATH} replace />;

  if (supportDeskBrand !== brand.id) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background p-6">
        <div className="flex max-w-md flex-col items-center gap-4 text-center">
          <h1 className="text-xl font-semibold text-foreground">Esta cuenta es de otra mesa de ayuda</h1>
          <p className="text-sm text-muted-foreground">
            Tu usuario pertenece a la mesa de ayuda de otra marca. Ingresa desde la plataforma de esa marca para ver tu bandeja.
          </p>
          <Button variant="outline" onClick={signOut} className="gap-2">
            <LogOut className="h-4 w-4" /> Cerrar sesión
          </Button>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
